<template>
  <button type="button" class="btn btn-sm ms-1" :class="{ 'btn-danger': isSent, 'btn-dark': !isSent }" data-bs-toggle="tooltip" :title="buttonTitle" @click="checkSend" :disabled="loader">
    <i class="fa fa-envelope" v-if="!loader"></i>
    <b-spinner v-else style="width: 16px; height: 16px;"></b-spinner>
  </button>
</template>
<script>
export default {
  props: {
    expertid: {
      type: [Number, String],
      required: true,
    },
    count: {
      type: [Number, String],
      required: false,
      default() {
        return 0;
      },
    },
  },
  data() {
    return {
      sent: 0,
      loader: false,
    };
  },
  computed: {
    isSent() {
      return Number(this.count) + this.sent > 0;
    },
    buttonTitle() {
      if (!this.isSent) {
        return "Send this expert a welcome email";
      }
      return "You have sent this expert the welcome email";
    },
  },
  methods: {
    checkSend() {
      const cnfrm = confirm("Send email?");
      if (cnfrm) {
        this.sendEmail();
      }
    },
    async sendEmail() {
      const url = "/admin/experts/send-welcome-email";
      this.loader = true;
      try {
        const response = await axios.post(url, {
          expert_id: this.expertid,
        });
        if (response.data.status === "OK")
            One.helpers('jq-notify', {type: 'info', icon: 'fa fa-info-circle me-1', message: 'Welcome email has been sent!'});
        this.sent++;
        this.loader = false;
      } catch (e) {
        console.log(e);
        if (e.response && e.response.data) {
            One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: e.response.data.message});
        } else {
            One.helpers('jq-notify', {type: 'danger', icon: 'fa fa-times me-1', message: 'An unknown error has occurred'});
        }
        this.loader = false;
      }
    },
  },
};
</script>
